import React, { useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { FolderIcon } from '../../folder-icon-component';
import { useCellSectionDecoratorStyle } from '../styles/tiles-grid-cell-drag-decorator-style';

export const TilesGridCellDragDecorator = ({
  draggable,
  children,
  item,
  dragItemsLength,
  onDrag,
  i18n,
  selected,
}) => {
  const classes = useCellSectionDecoratorStyle();

  const dragPreviewDescription = useMemo(() => {
    let dragItemsLengthInner = dragItemsLength;
    if (!selected) {
      dragItemsLengthInner += 1;
    }
    if (dragItemsLengthInner > 1) {
      return i18n.getString(_TL_('{{dragItemsLength}} items'), { dragItemsLength: dragItemsLengthInner });
    }
    return i18n.getString(_TL_('1 item'));
  }, [dragItemsLength, i18n, selected]);

  const renderDragPreview = useCallback(() => (
    <div className={classes.dragPreview}>
      {
          item.url || item.thumbnailUrl ? (
            <img
              src={item.thumbnailUrl || item.url}
              className={classes.dragPreviewImage}
              alt="drag preview"
            />
          ) : (
            <div className={classes.dragPreviewFolderWrapper}>
              <FolderIcon
                folderIconRootClassName={classes.dragPreviewFolder}
                isEmptyFolder={false}
              />
            </div>
          )
        }
      <div className={classes.dragPreviewCount}>{dragPreviewDescription}</div>
    </div>
  ), [classes, dragPreviewDescription, item.thumbnailUrl, item.url]);

  const onDragStart = useCallback((event) => {
    onDrag({ item });
    const container = document.createElement('div');
    const DragPreview = renderDragPreview;
    ReactDOM.render(<DragPreview />, container);
    const domElement = container.firstChild;
    document.body.appendChild(domElement);

    if (event && event.dataTransfer && event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(domElement, 0, 0);
    }
  }, [item, onDrag, renderDragPreview]);

  return (
    draggable ?
      <div
        className={classnames('grid-cell-drag-drop-decorator')}
        onDragStart={onDragStart}
        draggable
      >
        {children}
      </div> : children
  );
};

TilesGridCellDragDecorator.propTypes = {
  draggable: PropTypes.bool,
  children: PropTypes.node.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  item: PropTypes.shape({}),
  onDrag: PropTypes.func,
  dragItemsLength: PropTypes.number,
  selected: PropTypes.bool,
};

TilesGridCellDragDecorator.defaultProps = {
  draggable: false,
  item: {},
  onDrag: () => null,
  dragItemsLength: 1,
  selected: false,
};
